import IDImage from './IDImage';
import approveApiCall from './approve';
import checkKycApiCall from './checkKyc';
import createApiCall from './create';
import editApiCall from './edit';
import fundAccounts from './fundAccounts';
import detailApiCall from './old-detail';
import listApiCall from './oldList';
import portfolio from './portfolio';
import portfolioFlex from './portfolioFlex';
import portfolioFundGoals from './portfolioFundGoals';
import portfolioFunds from './portfolioFunds';
import portfolioStockGoals from './portfolioStockGoals';
import rejectApiCall from './reject';
import requiredResyncEContractLinkApiCall from './requiredResyncEContractLink';
import requiredResyncVSDStatusApiCall from './requiredResyncVSDStatus';
import stockAccount from './stockAccount';
import setUserStatusApiCall from './setStatus';
import updateAccountContractNHSVApiCall from './updateAccountContractNHSV';
import { createVcamAccount } from './vcam';

const ApiCall = {
  list: listApiCall,
  detail: detailApiCall,
  create: createApiCall,
  edit: editApiCall,
  delete: editApiCall,
  approve: approveApiCall,
  reject: rejectApiCall,
  createVcamAccount,
  IDImage,
  checkKyc: checkKycApiCall,
  fundAccounts,
  stockAccount,
  portfolio,
  portfolioFlex,
  portfolioFundGoals,
  portfolioFunds,
  portfolioStockGoals,
  setStatus: setUserStatusApiCall,
  updateAccountContractNHSVApiCall: updateAccountContractNHSVApiCall,
  requiredResyncEContractLink: requiredResyncEContractLinkApiCall,
  requiredResyncVSDStatus: requiredResyncVSDStatusApiCall,
};

export default ApiCall;

import detail from './detail';
import list from './list';

export const apiUserCall = { list, detail };
